import { create } from 'zustand'

interface UsePatronCheckInsDateRangeState {
  startDate: Date
  setStartDate: (x: Date) => void
  endDate: Date
  setEndDate: (x: Date) => void
  licensedEstablishmentId: number
  setLicensedEstablishmentId: (x: number) => void
}

const getDefaultStartDate = () => {
  const date = new Date()
  date.setDate(date.getDate() - 30)
  date.setHours(0, 0, 0, 0) // set to midnight 30 days ago
  return date
}

const getDefaultEndDate = () => {
  const date = new Date()
  date.setHours(23, 59, 59, 999)
  return date
}

export const usePatronCheckInsDateRangeState =
  create<UsePatronCheckInsDateRangeState>((set) => ({
    startDate: getDefaultStartDate(),
    setStartDate(x) {
      set({ startDate: x })
    },
    endDate: getDefaultEndDate(),
    setEndDate(x) {
      set({ endDate: x })
    },
    licensedEstablishmentId: -1,
    setLicensedEstablishmentId(x) {
      set({ licensedEstablishmentId: x })
    },
  }))
